/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { ProgressBar, Image, Button, Dropdown } from 'react-bootstrap';
import { setFinanceHouse } from '../../../actions/salesActions';
import { navigateTo } from '../../../actions/navigationActions';
import { VEHICLE_LOOKUP } from '../../../routes/routes';
import { postToController } from '../../../actions/apiActions';
import './CarFinance.css';

class CarFinance extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            financeHouseList: [],
            nextDisabled: true,
            openDisabled: true,
            selectedFinanceHouse: "",
            selectedFinanceHouseId: -1,
            selectedFinanceHouseDropdown: false,
            buttonYesClicked: false,
            buttonNoClicked: false,
            isFinanceYes: false,
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.getFinanceHouses = this.getFinanceHouses.bind(this);
        this.handleFinanceSelection = this.handleFinanceSelection.bind(this);
        this.handleSelectedFinanceHouseDropdownToggle = this.handleSelectedFinanceHouseDropdownToggle.bind(this);
        this.handleYesButton = this.handleYesButton.bind(this);
        this.handleNoButton = this.handleNoButton.bind(this);
    }

    async checkSubmit() {
        await this.setState({ nextDisabled: false });
    }

    async componentDidMount() {
        if (this.state.financeHouseList.length === 0) {
            this.getFinanceHouses();
        }
    }

    async handleYesButton() {
        await this.setState({ openDisabled: false, buttonNoClicked: false  });
        await this.setState({ nextDisabled: true, buttonYesClicked: true, isFinanceYes: true  });
    }

    async handleNoButton() {
        await this.setState({ openDisabled: true, buttonNoClicked: true  });
        await this.setState({ nextDisabled: false, buttonYesClicked: false, isFinanceYes: false });
    }

    handleClick() {
        this.props.dispatchSetFinanceHouse(this.state.selectedFinanceHouse,this.state.selectedFinanceHouseId)
    }

    async handleFinanceSelection(e: any) {
        let coverItem = this.state.financeHouseList.filter(function (item) {
            return item.id == e
        })
        await this.setState({
            selectedFinanceHouse: coverItem[0].description,
            selectedFinanceHouseId: coverItem[0].id,
        });
        this.setState({ nextDisabled: coverItem[0] === undefined });
    }

    async handleBack(e: any) {
        this.props.redirectTo(VEHICLE_LOOKUP)
    }

    async getFinanceHouses() {
        await postToController(this.props.dispatch, 'GetFinanceHouses', JSON.stringify({ Parameter : this.props.profile.countryId})).then(async (response) => {
            await this.setState({ financeHouseList: response });
            return true;
        })
    }

    async handleSelectedFinanceHouseDropdownToggle(e: any) {
        await this.setState({
            selectedFinanceHouseDropdown: !this.state.selectedFinanceHouseDropdown
        });
    }

    public render() {
        let financeHouseDrop = [];
        if (this.state.financeHouseList.length > 0) {
            financeHouseDrop = this.state.financeHouseList.map((item) => {
                return <Dropdown.Item eventKey={item.id}>{item.description}</Dropdown.Item>
            });
        }
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-2 col-lg-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12 pl-lg-0">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div className="ma-top-21px text-center">
                                    <p className="text-16 font-weight-500">Is your car already financed</p>
                                </div>
                                <div className="row d-flex justify-content-center">
                                    <div className="col-md-2 col-6">
                                        <button className={this.state.buttonYesClicked ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnYes" onClick={this.handleYesButton}>Yes</button>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <button className={this.state.buttonNoClicked ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnNo" onClick={this.handleNoButton}>No</button>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-lg-2 p-0"></div>
                                    <div className="col-lg-10 mb-2 p-lg-0">
                                        <p className={this.state.isFinanceYes ? 'text-left mb-1' : 'text-left mb-1 p-disabled'}><b>Where is it financed</b></p>
                                        <Dropdown
                                            id="financeHouse-select-dropdown"
                                            className="fit-full"
                                            onSelect={this.handleFinanceSelection}
                                            onToggle={this.handleSelectedFinanceHouseDropdownToggle}>
                                            <Dropdown.Toggle id="dropdown-basic" disabled={this.state.openDisabled}>
                                                <div className="row dropdown-height">
                                                    <div className="dropdown-basic-title-text col-11">
                                                        {this.state.selectedFinanceHouse}
                                                        {!this.state.selectedFinanceHouse &&
                                                            <p>Choose an option</p>
                                                        }
                                                    </div>
                                                    <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectedFinanceHouseDropdown ? 'visible' : 'invisible'} alt="" />
                                                    <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectedFinanceHouseDropdown ? 'invisible' : 'visible'} alt="" />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu id='financeHouseDropDown'>
                                                {financeHouseDrop}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12">
                                        <Button className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetFinanceHouse: (financeHouse: any,financeHouseId : number) => dispatch(setFinanceHouse(financeHouse,financeHouseId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarFinance);